// extracted by mini-css-extract-plugin
export default {"text":"PlaidRenewModalContent_text__2MYQ2","footer":"PlaidRenewModalContent_footer__27GEQ"};